const map = {
	"./Big-O Notation.md": 2543,
	"./Design Patterns.md": 3530,
	"./Hashing.md": 6339,
	"./How did I design TetroRhythm.md": 4371,
	"./Perfect Language.md": 9182,
	"./Sorting.md": 8383,
	"./TetroRhythm.png": 4050,
	"./Understanding Electricity 101.md": 1420,
	"./egg.md": 3638
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5140;